import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/bootstrap-vue";
import "./plugins/vee-validate";
import Notifications from "vue-notification";
import MemberInfo from "@/components/MemberInfo";
import i18n from "./i18n";

import dayJs from "./plugins/dayjs";
import CKEditor from "ckeditor4-vue";

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(dayJs);
Vue.use(Notifications);
Vue.use(CKEditor);

Vue.component("MemberInfo", MemberInfo);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
